module.exports = __webpack_public_path__ + "img/speaker-s3.a09c1244.jpg";